<template>
  <div class="text" v-if="codeTimer > 0">
    Запросить код повторно через {{ codeTimer }} секунд
  </div>
  <div v-else>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onBeforeUnmount, defineProps, onMounted } from "vue";

// Определяем пропсы с типами
interface Props {
  retryAfter: number;
}

const props = defineProps<Props>();

const codeTimer = ref<number>(0);
let timerInterval: any = null;

const startTimer = (retryAfterTimestamp: number) => {
  const currentTime = Math.floor(Date.now() / 1000); // Текущее время в секундах
  codeTimer.value = retryAfterTimestamp - currentTime;

  if (timerInterval !== null) {
    clearInterval(timerInterval);
  }

  timerInterval = setInterval(() => {
    if (codeTimer.value > 0) {
      codeTimer.value--;
    } else {
      codeTimer.value = 0;
      clearInterval(timerInterval);
      timerInterval = null; // Устанавливаем обратно в null
    }
  }, 1000);
};

watch(
  () => props.retryAfter,
  (newVal) => {
    if (newVal) {
      startTimer(newVal);
    }
  }
);

// Запуск таймера при монтировании, если retryAfter уже задан
onMounted(() => {
  if (props.retryAfter) {
    startTimer(props.retryAfter);
  }
});

onBeforeUnmount(() => {
  if (timerInterval !== null) {
    clearInterval(timerInterval);
  }
});
</script>

<style lang="scss" scoped>
.text {
  margin-top: 30px;
  margin-bottom: 0;
  text-align: center;
}
</style>